import { lazy } from 'react';
import AddAvailability from '../../views/Settings/Employees/Availability/AddAvailability';
import AddAvailabilityNew from '../../views/Settings/Employees/Availability/AddAvailabilityNew';
import EmployeeShiftCalendar from '../../views/Settings/Employees/Departments/EmployeeShiftCalendar';

const ViewEmployeeForm = lazy(() => import('../../views/Settings/Employees/ManageEmployee/ViewEmployeeForm'));
const EmployeeForm = lazy(() => import('../../views/Settings/Employees/ManageEmployee/AddEmployee/EmployeeForm'));
const CertificationForm = lazy(() => import('../../views/Settings/Employees/ManageEmployee/AddEmployee/Certifications/CertificationForm'));
const SecurityRolesForm = lazy(() => import('../../views/Settings/Employees/SecurityRoles/SecurityRolesForm'));
const DepartmentsForm = lazy(() => import('../../views/Settings/Employees/Departments/DepartmentsForm'));
const EmployeeSettingRoute = [
    {
        path: '/manage-employee/add',
        name: 'Manage Employee',
        exact: true,
        component: EmployeeForm,
        items: [{ path: '/certifications/:employeeId', name: 'Employee', exact: true, component: CertificationForm }],
    },
    {
        path: '/manage-employee/edit/:id',
        name: 'Employee',
        exact: true,
        component: EmployeeForm,
        items: [{ path: '/certifications/:employeeId', name: 'Employee', component: CertificationForm }],
    },
    {
        path: '/manage-employee/view/:id',
        name: 'Employee',
        exact: true,
        component: ViewEmployeeForm,
    },
    {
        path: '/availability/add',
        name: 'Add Employee Availablity',
        exact: true,
        component: AddAvailability,
    },
    {
        path: '/availability/edit/:id',
        name: 'Employee Availablity',
        exact: true,
        component: AddAvailability,
    },

    {
        path: '/availability-new/add',
        name: 'Add Employee Availablity',
        exact: true,
        component: AddAvailabilityNew,
    },
    {
        path: '/availability-new/edit/:id',
        name: 'Employee Availablity',
        exact: true,
        component: AddAvailabilityNew,
    },
    {
        path: '/departments/add',
        name: 'Add Department',
        exact: true,
        component: DepartmentsForm,
    },
    {
        path: '/departments/edit/:id',
        name: 'Department',
        exact: true,
        component: DepartmentsForm,
    },

    {
        path: '/department-employee-availablity/:id',
        name: 'Add Department',
        exact: true,
        component: EmployeeShiftCalendar,
    },

    {
        path: '/security-roles/add',
        name: 'Add Security Role',
        exact: true,
        component: SecurityRolesForm,
    },
    {
        path: '/security-roles/edit/:id',
        name: 'Security Role',
        exact: true,
        component: SecurityRolesForm,
    },
];
export default EmployeeSettingRoute;
